import { createBrowserHistory } from "history";

const history = createBrowserHistory();
export function refreshCurrentPage() {
  history.push("/temp");
  history.back();
}
export default history;
